import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const currencies = ["SEK"] as const;
type CurrencyCode = (typeof currencies)[number];
const currency = toObjectMap<CurrencyCode>([...currencies]);

const currencyCodeZodSchema: z.ZodSchema<CurrencyCode> = z.enum(currencies);

export { currencies, currency, currencyCodeZodSchema };
export type { CurrencyCode };
